export const API_URL = process.env.VUE_APP_API_URL
export const API_URL_INTEGRATION = process.env.VUE_APP_API_INTEGRATION_URL
export const APP_ENV = process.env.VUE_APP_NODE_ENV
